import React from "react";
import BusinessLink from "../../layouts/DefaultBusinessLink";

const Aboutus = ({ aboutusDetail, themeColorDetail, websiteBackgroundColor, websiteTextColor }) => {

  const descriptionColor = aboutusDetail?.description_color || websiteTextColor || '#515151'
  const headingStyle = {
    color: aboutusDetail?.heading_color || themeColorDetail,
    fontFamily: aboutusDetail?.heading_font,
    fontSize: `${aboutusDetail?.heading_size}px`,
  };
  const subHeadingStyle = {
    color: aboutusDetail?.sub_heading_color || websiteTextColor || '#1d2228',
    fontFamily: aboutusDetail?.sub_heading_font,
    fontSize: `${aboutusDetail?.sub_heading_size}px`,
  };
  // const aboutUsImageTempUrl = `${window.location.origin}/assets/default/about-us-image-default.jpg`

  return (
    <div className="section" style={{ backgroundColor: websiteBackgroundColor }}>
      <div className="container">
        <div className="row align-items-center">
          {aboutusDetail?.image_url &&
            <div className="col-lg-6 mb-lg-30 ct-single-img-wrapper" style={{textAlign:'center'}}>
              <img
                src={aboutusDetail?.image_url}
                alt="img"
              />
              <div className="ct-dots" />
            </div>
          }
          <div className="col-lg-6">
            <div className="section-title-wrap mr-lg-30">
              {aboutusDetail?.heading &&
                <h5 className="custom-primary" style={headingStyle}>
                  {aboutusDetail?.heading}
                </h5>
              }
              {aboutusDetail?.sub_heading &&
                <h2 className="title" style={subHeadingStyle}>
                  {aboutusDetail?.sub_heading}
                </h2>
              }
              {aboutusDetail?.description &&
                <p className="subtitle" style={{ color: descriptionColor }}>
                  {aboutusDetail?.description}
                </p>
              }
              <BusinessLink className="btn-header btn-brand btn-footer" to="/menu">Check Our Menu</BusinessLink>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aboutus;
